import axios from 'axios'
import { useMutation, useQuery } from 'react-query'

const leadUrl = `${process.env.NEXT_PUBLIC_API_ROOT}/api/leads`

const useLeadById = (params, enabled) => useQuery(['leadId', params], async () => {
  const url = `${leadUrl}/find`
  const { data } = await axios.get(url, { params })
  return data
}, {
  enabled,
  refetchOnWindowFocus: false,
  refetchOnmount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: 1000 * 60 * 24,
})

const useLead = (name) => useMutation(
  (content) => {
    const params = {
      origin: window.location.origin,
      form_name: name,
      domain: window.location.host,
      content: JSON.stringify(content),
    }
    if (content?.leadId) {
      return axios.put(`${leadUrl}/${content?.leadId}`, params)
    }
    return axios.post(leadUrl, params)
  },
)

export { useLead, useLeadById }
